import { useState } from 'react';
import EntityManager from '@/pages/admin/components/EntityManager';
import BulkUpload from '@/pages/admin/gallery/BulkUpload';
import MediaPicker from '@/pages/admin/gallery/MediaPicker';
import { galleryFields, galleryColumns } from '@/pages/admin/entityConfigs';

export default function GalleryPage() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div>
      <BulkUpload onUploaded={() => setRefreshKey((k) => k + 1)} />
      <MediaPicker onAdded={() => setRefreshKey((k) => k + 1)} />
      <EntityManager
        key={refreshKey}
        table="gallery_images"
        fields={galleryFields}
        columns={galleryColumns}
        orderBy="sort_order"
        ascending
        searchKeys={['alt', 'category', 'title']}
        addLabel="Add Photo"
      />
    </div>
  );
}